import { CommonModule } from '@angular/common';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { InactiveUserModule } from 'src/app/core/components/inactive-user/inactive-user.module';
import { UserService } from 'src/app/core/services/user.service';
import { LangSwitcherModule } from 'src/app/shared/components/lang-switcher/lang-switcher.module';
import { UserModel } from 'src/app/shared/models/user.model';
import { FaqMainComponent } from './faq-main.component';
import { HeaderMenuModule } from 'src/app/shared/components/header-menu/header-menu.module';
import { HeaderModule } from 'src/app/shared/components/header/header.module';

export function userFactory(provider: UserService) {
    return () => {
        return new Promise((resolve => {
            provider.loggedUser = provider.getStoredLoggedUser() || new UserModel();
            resolve(provider.loggedUser);
        }));
    };
}

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        LangSwitcherModule,
        InactiveUserModule,
        HeaderMenuModule,
        HeaderModule,
    ],
    declarations: [FaqMainComponent],
    providers: [
        {provide: APP_INITIALIZER, useFactory: userFactory, deps: [UserService], multi: true}
    ]
})
export class FaqMainModule { }
